export default __webpack_public_path__ + "static/media/xion.ac507dbc.png";